import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Link } from "@hopper-ui/components";
import { IconOpenLink } from "@intentui/icons";
import type { PressEvent } from "react-aria-components";

interface Props {
    href: string;
    children: string;
    onPress?: (event: PressEvent) => void;
}

// A card's way to what it's about, in a new tab: as quiet as the member card's email, with the new-tab icon saying where
// it goes, so the chip that opened the card only opens it. The label and icon sit in the link's own row, in that order.
export const HoverCardPageLink = ({ href, children, onPress }: Props) => {
    const { tShared } = useSharedTranslation();

    return (
        <Link href={href} isExternal variant="secondary" size="xs" isQuiet color="neutral-weak" alignSelf="start" aria-label={`${children}, ${tShared("opensInNewTab")}`} onPress={onPress}>
            {children}
            <IconOpenLink />
        </Link>
    );
};
